import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloError } from 'apollo-client';

import type { ExperienceAttributes } from '@confluence/experience-tracker/entry-points/ExperienceEvent';
import {
	ExperienceStart,
	ExperienceStop,
} from '@confluence/experience-tracker/entry-points/component';

import { LoadingState } from './homeViewsQueryHelpers';

type ExperienceTrackingType = {
	experienceName: string;
	loading: LoadingState;
	error?: ApolloError;
	attributes?: ExperienceAttributes;
};

export const ExperienceTracking: FC<ExperienceTrackingType> = ({
	experienceName,
	loading,
	error,
	attributes,
}) => {
	return (
		<Fragment>
			<ExperienceStart name={experienceName} />
			{loading === LoadingState.done && (
				<ExperienceStop name={experienceName} error={error} attributes={attributes} />
			)}
		</Fragment>
	);
};
